import React, { useState, useEffect } from "react";
import { Plus } from "lucide-react";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";

import styles from "../../styles/automation-styles";

import MacroAutomationCard from "src/components/macro/macro-automation-card";
import MacroActionMenu from "src/components/macro/macro-action-menu";

// Main MacroList Component
const MacroList = (props) => {
  const [activeTab, setActiveTab] = useState(parseInt(localStorage.getItem("activeMacroTab")) || 0);
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
  const [selectedMacro, setSelectedMacro] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    localStorage.setItem("activeMacroTab", tabIndex);
  };

  const handleMenuOpen = (e, macro) => {
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();
    setMenuPosition({
      x: rect.left + window.scrollX - 150,
      y: rect.bottom + window.scrollY - 25,
    });
    setSelectedMacro(macro);
    setMenuOpen(true);
  };

  const handleMenuClose = () => {
    setMenuOpen(false);
  };

  // Get macros for current active tab and filter by search term
  const macros = (props.data[activeTab] || []).filter((macro) => {
    if (!searchTerm) return true;

    const searchLower = searchTerm.toLowerCase();
    return (
      macro.title.toLowerCase().includes(searchLower) ||
      macro.condition.toLowerCase().includes(searchLower)
    );
  });

  // Handle click outside menu to close it
  useEffect(() => {
    const handleClickOutside = () => {
      setMenuOpen(false);
    };

    if (menuOpen) {
      document.addEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <div style={styles.contentWrapper}>
      <h1 style={styles.heading}>Macros</h1>

      <div style={styles.tabContainer}>
        <div style={styles.tabRow}>
          <span style={styles.tabLabel}>Tipos de Macros:</span>
          <div style={styles.tabsWrapper}>
            <button
              style={{
                ...styles.tabButton,
                ...(activeTab === 0 ? styles.activeTabButton : {}),
              }}
              onClick={() => handleTabClick(0)}
            >
              Macros Privadas
              <span style={styles.tabCount}>{props.data[0]?.length ?? 0}</span>
            </button>

            <button
              style={{
                ...styles.tabButton,
                ...(activeTab === 1 ? styles.activeTabButton : {}),
              }}
              onClick={() => handleTabClick(1)}
            >
              Macros Compartilhadas com você
              <span style={styles.tabCount}>{props.data[1]?.length ?? 0}</span>
            </button>

            <button
              style={{
                ...styles.tabButton,
                ...(activeTab === 2 ? styles.activeTabButton : {}),
              }}
              onClick={() => handleTabClick(2)}
            >
              Macros Compartilhadas pelos times
              <span style={styles.tabCount}>{props.data[2]?.length ?? 0}</span>
            </button>
          </div>
        </div>
        {/*<SearchBar onSearch={setSearchTerm} />*/}
      </div>

      {/* <p style={styles.infoText}>
        Estas regras são automatizadas com base na antiguidade de um ticket. Por
        exemplo, enviar lembretes aos clientes, encaminhar tickets que ainda não
        foram tratados, etc. As regras são executadas sequencialmente.
        <button style={styles.moreInfoButton}>Mais informações</button>
      </p> */}

      <div style={styles.actionsRow}>
        {props.allowCreateMacro && (
          <Button
            style={styles.newRuleButton}
            component={Link}
            {...{
              to: `/${props.match.params.lang}/macro-registration`,
            }}
          >
            <Plus size={18} />
            <span>Nova macro</span>
          </Button>
          )
        }
      </div>

      {macros.length > 0 ? (
        macros.map((macro) => (
          <MacroAutomationCard
            key={macro.id}
            automation={macro}
            onMenuOpen={handleMenuOpen}
            updateActiveAsync={props.updateActiveAsync}
            getItemForUpdateAsync={props.getItemForUpdateAsync}
          />
        ))
      ) : (
        <div style={styles.emptyContainer}>
          <p style={styles.emptyText}>
            {searchTerm
              ? "Nenhum macro encontrado com os termos de pesquisa."
              : "Não existem macros nesta categoria. Clique em 'Nova macro' para criar um."}
          </p>
        </div>
      )}

      <MacroActionMenu
        isOpen={menuOpen}
        position={menuPosition}
        onClose={handleMenuClose}
        selectedAutomation={selectedMacro}
        deleteAsync={props.deleteAsync}
        cloneItemAsync={props.cloneItemAsync}
        getItemForUpdateAsync={props.getItemForUpdateAsync}
      />
    </div>
  );
};
export default MacroList;